/* eslint-disable */
import { addWidgetsFromContext } from "@insite/client-framework/Components/ContentItemStore";

const widgets = require.context("../../blueprints/awc/src/App/Widgets", true, /.tsx$/);
addWidgetsFromContext(widgets);
